import React from "react";
import Modal from "react-modal";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getOAuthToken } from "app/pages/Auth/OAuth/oAuthActionCreators";
import OAuthLoadingMessage from "app/pages/Auth/OAuth/OAuthLoadingMessage";
import { sendTagOnOauthAccessTokenFailed } from "app/utils/analytics";

const style = {
	overlay: {
		backgroundColor: "rgba(43, 56, 63, .9)",
		zIndex: 6,
	},
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		border: "none",
		background: "none",
		overflow: "hidden",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
	},
};

export default WrappedComponent => {
	class HOC extends React.Component {
		constructor(props) {
			super(props);
			this.state = {
				showModal: false,
			};
		}

		componentDidMount() {
			const { oAuthorizationCode } = this.props;
			const redirectUri = window.location.origin + window.location.pathname;

			if (oAuthorizationCode) {
				this.setState({
					showModal: true,
				});

				this.props
					.getOAuthToken({
						code: oAuthorizationCode,
						redirectUri,
					})
					.then(() => {
						this.setState({
							showModal: false,
						});
					})
					.catch(() => {
						this.props.history.replace({
							pathname: "/technical-error/sso",
							search: `?redirectUri=${redirectUri}`,
						});
						sendTagOnOauthAccessTokenFailed();
					});
			}
		}

		render() {
			return (
				<div>
					<WrappedComponent {...this.props} />
					<Modal isOpen={this.state.showModal} style={style}>
						<OAuthLoadingMessage />
					</Modal>
				</div>
			);
		}
	}

	HOC.propTypes = {
		oAuthorizationCode: PropTypes.string,
		getOAuthToken: PropTypes.func,
		query: PropTypes.object,
		history: PropTypes.object,
	};

	const mapDispatchToProps = dispatch => {
		return bindActionCreators({ getOAuthToken }, dispatch);
	};

	return withRouter(
		connect(
			null,
			mapDispatchToProps
		)(HOC)
	);
};
